<template>
  <div class="header">
    <div class="header-box">
      <div class="header-status" @click="toggleDropdown">
        <div class="header-line" :style="{ backgroundColor: statusColor }"></div>

        <div class="header-text">{{ statusText }}</div>
      </div>
    </div>

    <!-- 下拉菜单 -->

    <div v-if="showDropdown" class="dropdown-menu">
      <!-- 使用 computed 属性过滤后的列表 -->

      <div v-for="(item, key) in filteredStatusList" :key="key" class="dropdown-item" @click="setStatus(key)">
        <div class="status-dot" :style="{ backgroundColor: item.color }"></div>

        <span>{{ item.text }}</span>
      </div>
    </div>

    <img class="header-notice" src="@/assets//svg/notice.svg" />

    <el-popover placement="bottom-end" trigger="click" width="208.92px" popper-class="header-user-menu-popover"
      :visible-arrow="true">
      <div class="header-user-menu">
        <button v-for="row in userMenuRows" :key="row.key" type="button" class="header-user-menu__item"
          :class="{ 'header-user-menu__item--divider': row.dividerAfter }" @click="onUserMenuRow(row)">
          <span class="header-user-menu__icon-wrap">
            <i v-if="row.icon" :class="row.icon" class="header-user-menu__icon" />
            <span v-else-if="row.themeDot" class="header-user-menu__theme-dot" />
          </span>
          <span class="header-user-menu__label">{{ row.label }}</span>
        </button>
      </div>
      <head-image
        slot="reference"
        class="header-kefu"
        :name="mine.nickName"
        :url="mine.headImage"
        :size="32"
        radius="12px"
        :online="mine.online"
        :online-status="mine.onlineStatus"
      />
    </el-popover>
  </div>
</template>

<script>
import HeadImage from "../../../components/common/HeadImage.vue";

export default {
  props: {
    mine: {
      type: Object,

      default: null
    }
  },

  components: {
    HeadImage
  },

  data() {
    return {
      showDropdown: false,
      status: "online",
      statusMap: {
        online: { color: "#22C55E", text: "在线" },
        away: { color: "#C9871C", text: "挂起" },
        busy: { color: "#822600", text: "忙碌" },
        offline: { color: "#BABABA", text: "离线" }
      },

      userMenuRows: [
        { key: "account", icon: "el-icon-user", label: "账号信息", dividerAfter: true },
        // { key: "language", icon: "el-icon-share", label: "语言" },
        // { key: "theme", themeDot: true, label: "主题色", dividerAfter: true },
        { key: "ipWhitelist", icon: "el-icon-lock", label: "登录IP白名单" },
        { key: "loginVerify", icon: "el-icon-success", label: "二次登录验证", dividerAfter: true },
        { key: "network", icon: "el-icon-connection", label: "网络诊断", dividerAfter: true },
        { key: "logoutDevice", icon: "el-icon-remove", label: "退出当前的设备登录状态", dividerAfter: true },
        { key: "logoutAll", icon: "el-icon-right", label: "退出所有的设备登录状态" }
      ]
    };
  },

  watch: {
    mine: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val || typeof val !== "object") {
          return;
        }
        const rev = {
          1: "online",
          2: "away",
          3: "busy",
          4: "offline"
        };
        if (val.onlineStatus != null && val.onlineStatus !== "") {
          const key = rev[Number(val.onlineStatus)];
          if (key) {
            this.status = key;
          }
          return;
        }
        this.status = val.online ? "online" : "offline";
      }
    }
  },

  computed: {
    statusColor() {
      return this.statusMap[this.status]?.color || "#22C55E";
    },

    statusText() {
      return this.statusMap[this.status]?.text || "在线";
    },

    filteredStatusList() {
      return Object.entries(this.statusMap)

        .filter(([key]) => key !== this.status)

        .reduce((acc, [key, value]) => {
          acc[key] = value;

          return acc;
        }, {});
    }
  },

  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },

    setStatus(status) {
      const codeMap = {
        online: 1,
        away: 2,
        busy: 3,
        offline: 4
      };
      const code = codeMap[status];
      if (code == null) {
        return;
      }
      this.showDropdown = false;
      this.$http({
        url: "/user/setOnlineStatus?status=" + code,
        method: "post",
        data: {
          status: code
        }
      })
        .then(() => {
          this.$message.success("切换在线状态成功");
          this.userStore.applyOnlineStatus(code);
        })
        .catch(() => {
          this.$message.error("切换在线状态失败");
        });
    },

    onUserMenuRow(row) {
      if (!row || !row.key) return;
      this.$emit("user-menu", row.key);
    },

    openKeFu() {
      console.log("openKeFu");
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  height: 65px;

  position: relative;

  display: flex;

  align-items: center;

  justify-content: flex-end;

  padding-right: 30px;

  border-bottom: 1px solid #e5e7eb;

  background: #fff;

  .header-box {
    display: flex;

    height: 100%;

    .header-status {
      display: flex;

      align-items: center;

      cursor: pointer;
    }

    .header-line {
      width: 8px;

      height: 8px;

      margin-right: 10px;

      border-radius: 50%;

      background-color: #22c55e;
    }

    .header-text {
      color: #374151;

      font-size: 14px;

      font-weight: 400;
    }
  }

  .dropdown-menu {
    position: absolute;

    top: 56px;

    right: 85px;

    background-color: #fff;

    border-radius: 10px;

    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    z-index: 100;

    filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.15)) drop-shadow(-2px -2px 4px rgba(0, 0, 0, 0.15));

    &::before {
      content: "";

      position: absolute;

      top: -8px;

      left: 15px;

      width: 0;

      height: 0;

      border-left: 8px solid transparent;

      border-right: 8px solid transparent;

      border-bottom: 8px solid #fff;

      z-index: 1001;
    }
  }

  .header-notice {
    width: 18px;

    height: 18px;

    padding: 0 10px;
  }

  .header-kefu {
    width: 32px;

    height: 32px;

    cursor: pointer;

    border-radius: 12px;
  }

  .dropdown-item {
    padding: 5px 10px;

    display: flex;

    align-items: center;

    cursor: pointer;

    &:hover {
      background-color: #f3f4f6;

      border-radius: 10px;
    }

    .status-dot {
      width: 8px;

      height: 8px;

      border-radius: 50%;

      margin-right: 10px;
    }

    span {
      color: #374151;

      font-size: 14px;

      font-weight: 400;
    }
  }
}
</style>

<!-- popover 挂载到 body，需非 scoped -->

<style lang="scss">
/* 与设计稿一致：白底、浅蓝描边、12px 圆角、右上箭头 */

$header-menu-border: #bfd8fb;
$header-menu-text: #303133;
$header-menu-icon: #606266;
$header-menu-divider: #ebeef5;
$header-menu-hover: #f5f8fc;
$header-theme-dot: #2d5af1;

.header-user-menu-popover {
  border-radius: 8px !important;
  background: #FFF !important;
  padding: 6px !important;

  &[x-placement^="bottom"] .popper__arrow {
    border-bottom-color: $header-menu-border !important;
  }

  &[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: #fff !important;

  }
}

.header-user-menu {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 12px;
}

.header-user-menu__item {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  // padding: 12px 16px;
  border: none;
  background: #fff;
  text-align: left;
  cursor: pointer;
  box-sizing: border-box;
  transition: background 0.15s ease;
  color: #374151;
  font-family: "Source Han Sans CN", "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  // height: 20px;
  padding: 0 10.35px 0 9px;
  // margin-bottom: 12px;

  &:hover {
    background: $header-menu-hover;
  }
}

/* 仅指定项底部虚化线：语言、登录IP白名单 不加 */
.header-user-menu__item--divider::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 0;
  height: 1px;
  pointer-events: none;
  background: linear-gradient(90deg,
      rgba(235, 238, 245, 0) 0%,
      rgba(235, 238, 245, 0.45) 14%,
      $header-menu-divider 32%,
      $header-menu-divider 68%,
      rgba(235, 238, 245, 0.45) 86%,
      rgba(235, 238, 245, 0) 100%);
}

.header-user-menu__icon-wrap {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin-right: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.header-user-menu__icon {
  font-size: 17px;
  color: $header-menu-icon;
}

.header-user-menu__theme-dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: $header-theme-dot;
  display: inline-block;
  box-sizing: border-box;
}

.header-user-menu__label {
  flex: 1;
  min-width: 0;
  color: $header-menu-text;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}
</style>
